import { PrivateInterceptor } from "../../Base/interceptors/PrivateInterceptor";


// enviar una notificacion
export const sendNotification = async(notification) => {
    const result = await PrivateInterceptor('notificaciones', 'POST', notification)
    return result;
}